import React from 'react'
import AddAdminContainer from '../../modules/Admins/containers/AddAdminContainer/AddAdminContainer'

const AddAdmin = () => {
  return (
    <AddAdminContainer />
  )
}

export default AddAdmin